import isEnumValue from '@orderna/admin-panel/src/utils/is-enum-value';

/**
 * @deprecated Use a status enum unique to each entity instead, e.g. UserStatus, CustomerStatus, CompanyStatus.
 * Represents the general status values available in the system.
 */
export enum Status {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
}

export const isStatus = (value: any) => isEnumValue(Status, value);

/**
 * Interface for objects that have a {@link Status} property.
 * @deprecated Use a status enum unique to each entity instead, e.g. UserStatus, CustomerStatus, CompanyStatus.
 */
export interface WithStatus {
  status: Status;
}
